/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { EspotAttachment } from './espot-attachment';
import { EspotMarketingContentDescription } from './espot-marketing-content-description';
import { EspotMarketingContentIdentifier } from './espot-marketing-content-identifier';
import { EspotMarketingContentImageMap } from './espot-marketing-content-image-map';
import { EspotMarketingContentMarketingContentDescription } from './espot-marketing-content-marketing-content-description';
import { EspotMarketingContentUserDataField } from './espot-marketing-content-user-data-field';

/**
 * 
 * @export
 * @interface EspotMarketingContent
 */
export interface EspotMarketingContent {
    /**
     * 
     * @type {string}
     * @memberof EspotMarketingContent
     */
    contentUrl?: string;
    /**
     * 
     * @type {EspotMarketingContentIdentifier}
     * @memberof EspotMarketingContent
     */
    marketingContentIdentifier?: EspotMarketingContentIdentifier;
    /**
     * 
     * @type {string}
     * @memberof EspotMarketingContent
     */
    contentFormatName?: string;
    /**
     * 
     * @type {Array<EspotMarketingContentImageMap>}
     * @memberof EspotMarketingContent
     */
    marketingContentImageMap?: Array<EspotMarketingContentImageMap>;
    /**
     * 
     * @type {Array<EspotMarketingContentMarketingContentDescription>}
     * @memberof EspotMarketingContent
     */
    MarketingContentDescription?: Array<EspotMarketingContentMarketingContentDescription>;
    /**
     * 
     * @type {Array<EspotMarketingContentDescription>}
     * @memberof EspotMarketingContent
     */
    marketingContentDescription?: Array<EspotMarketingContentDescription>;
    /**
     * 
     * @type {string}
     * @memberof EspotMarketingContent
     */
    contentInputOption?: EspotMarketingContentContentInputOptionEnum;
    /**
     * 
     * @type {string}
     * @memberof EspotMarketingContent
     */
    contentMimeType?: string;
    /**
     * 
     * @type {EspotAttachment}
     * @memberof EspotMarketingContent
     */
    attachment?: EspotAttachment;
    /**
     * 
     * @type {string}
     * @memberof EspotMarketingContent
     */
    contentFormatId?: string;
    /**
     * 
     * @type {Array<EspotMarketingContentUserDataField>}
     * @memberof EspotMarketingContent
     */
    userDataField?: Array<EspotMarketingContentUserDataField>;
    /**
     * 
     * @type {string}
     * @memberof EspotMarketingContent
     */
    contentClickAction?: EspotMarketingContentContentClickActionEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EspotMarketingContentContentInputOptionEnum {
    Area = 'Area',
    Source = 'Source'
}
/**
    * @export
    * @enum {string}
    */
export enum EspotMarketingContentContentClickActionEnum {
    None = 'None',
    Single = 'Single',
    Multiple = 'Multiple'
}



